export default __webpack_public_path__ + "static/media/chevron.502f2646.svg";